import 'angular/angular';
import 'angular-animate/angular-animate';
import 'angular-sanitize/angular-sanitize';
import 'ionic-sdk/release/js/angular-ui/angular-ui-router';
import 'ionic-sdk/release/js/ionic';
import 'ionic-sdk/release/js/ionic-angular';
import 'angular-stripe/src/index';
import 'opbeat-angular/opbeat-angular.min';

// Additional
import 'ng-cordova';
import angularFileSaver from 'angular-file-saver';

// App dependencies
import appRun from './app.run';
import appConfig from './app.config';
import appController from './app.controller';
import appDirectives from './app.directives';
import appServices from './app.services';
import campaignsModule from './components/campaigns/campaigns.module';
import cartModule from './components/cart/cart.module';
import contactsModule from './components/contacts/contacts.module';
import emailModule from './components/email/email.module';
import investorsModule from './components/investors/investors.module';
import selectionsModule from './components/selections/selections.module';
import settingsModule from './components/settings/settings.module';
import tasksModule from './components/tasks/tasks.module';
import teamModule from './components/team/team.module';
import userModule from './components/user/user.module';
import imprintModule from './components/imprint/imprint.module';
import extrasModule from './components/extras/extras.module';
import rfpsModule from './components/rfps/rfps.module';

const appModule = angular
    .module('advinda', [
        'cleave.js',
        'ionic',
        'ngCordova',
        'pascalprecht.translate',
        'LocalStorageModule',
        'restangular',
        'angular-stripe',
        'chart.js',
        'angularFileUpload',
        'ion-datetime-picker',
        'ionic-toast',
        'youtube-embed',
        angularFileSaver,
        'ngOpbeat',
        appDirectives.name,
        appServices.name,
        campaignsModule.name,
        cartModule.name,
        contactsModule.name,
        emailModule.name,
        imprintModule.name,
        investorsModule.name,
        selectionsModule.name,
        settingsModule.name,
        tasksModule.name,
        teamModule.name,
        userModule.name,
        extrasModule.name,
        rfpsModule.name
    ])
    .controller('AppController', appController)
    .constant('DATE_FORMAT', 'MMM dd, yyyy')
    .run(appRun)
    .config(appConfig)
    .directive('spinnerAdvinda', function () {
        return {
            template: '<svg width="40" height="40"><image xlink:href="assets/spinner/advinda-spinner.svg" src="spinner.png" width="40" height="40"/></svg>'
        };

    });

export default appModule;



/** WEBPACK FOOTER **
 ** ./src/app/app.js
 **/